import { render, staticRenderFns } from "./page-qrdetail.vue?vue&type=template&id=b946e556&scoped=true&"
import script from "./page-qrdetail.vue?vue&type=script&lang=js&"
export * from "./page-qrdetail.vue?vue&type=script&lang=js&"
import style0 from "./page-qrdetail.vue?vue&type=style&index=0&id=b946e556&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b946e556",
  null
  
)

export default component.exports